import { render, staticRenderFns } from "./newProductsMore.vue?vue&type=template&id=3759ba14&scoped=true"
import script from "./newProductsMore.vue?vue&type=script&lang=js"
export * from "./newProductsMore.vue?vue&type=script&lang=js"
import style0 from "./newProductsMore.vue?vue&type=style&index=0&id=3759ba14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3759ba14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3759ba14')) {
      api.createRecord('3759ba14', component.options)
    } else {
      api.reload('3759ba14', component.options)
    }
    module.hot.accept("./newProductsMore.vue?vue&type=template&id=3759ba14&scoped=true", function () {
      api.rerender('3759ba14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/more/newProductsMore.vue"
export default component.exports